import { DashboardTile } from "components/Dashboard/DashboardTile";

import { useWasteOverviewState } from "../WasteOverviewContext";
import { TotalWasteChart } from "./Charts/TotalWasteChart";

export function TotalWasteTile() {
  const {
    overviewState: { isPending },
  } = useWasteOverviewState();
  return (
    <DashboardTile size={12} sx={{ opacity: isPending ? 0.5 : 1 }}>
      <DashboardTile.Header
        title="Total Waste"
        infoTooltip={
          "Total waste in pounds across all waste facilities. Totals are calculated " +
          "from vendor line items, but if no vendor data is present, we will use " +
          "e‑Manifest data."
        }
      />
      <DashboardTile.ContentArea>
        <TotalWasteChart />
      </DashboardTile.ContentArea>
    </DashboardTile>
  );
}
